














import MenuLink from './MenuLink.vue'
import { Component, Prop, PropSync, Vue } from 'vue-property-decorator'
import searcherry from '@/services/Searcherry/Searcherry'

@Component({
  name: 'menu-link-category',
  components: { MenuLink }
})
export default class MenuLinkCategory extends Vue {
  @Prop() category: any
  @PropSync('searchPhraseProp', { type: String }) searchPhrase!: string

  clickCategory () {
    searcherry.generateEvent('click-category')
  }
}
